import React, { Fragment, useState, useMemo, useEffect, dispatch, state } from "react";
import { Link } from "react-router-dom";
import { useTable, useFilters, useGlobalFilter, usePagination, useSortBy } from 'react-table';
import { getNewRrtbfApprovalTasks, getRrtbfApprovalHistory, submitRTBFApprovalTasks } from '../../../services/ApprovalService';
import { getDbtJobs, getFailedDbtJobs, getSuccessfulDbtJobs } from '../../../services/DbtService';
import PageTitle from "../../layouts/PageTitle";
import {
    Row,
    Col,
    Card,
    table,
    ButtonGroup,
    Button,
    Table,
    Badge,
    Dropdown,
    Alert,
    ProgressBar,
} from "react-bootstrap";
import { useOktaAuth } from '@okta/okta-react';
import moment from 'moment';
/// imge
import avatar1 from "../../../images/avatar/1.jpg";
import avatar2 from "../../../images/avatar/2.jpg";
import avatar3 from "../../../images/avatar/3.jpg";

// DBT logo
import dbtLogo from "../../../images/dbt-svgrepo-com.svg";
import { useMsal } from "@azure/msal-react";

const emojis = {
    welcome: (
        <svg
            viewBox='0 0 24 24'
            width='24'
            height='24'
            stroke='currentColor'
            strokeWidth='2'
            fill='none'
            strokeLinecap='round'
            strokeLinejoin='round'
            className='me-2'
        >
            <circle cx='12' cy='12' r='10'></circle>
            <path d='M8 14s1.5 2 4 2 4-2 4-2'></path>
            <line x1='9' y1='9' x2='9.01' y2='9'></line>
            <line x1='15' y1='9' x2='15.01' y2='9'></line>
        </svg>
    ),

    done: (
        <svg
            viewBox='0 0 24 24'
            width='24'
            height='24'
            stroke='currentColor'
            strokeWidth='2'
            fill='none'
            strokeLinecap='round'
            strokeLinejoin='round'
            className='me-2'
        >
            <path d='M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3'></path>
        </svg>
    ),

    success: (
        <svg
            viewBox='0 0 24 24'
            width='24'
            height='24'
            stroke='currentColor'
            strokeWidth='2'
            fill='none'
            strokeLinecap='round'
            strokeLinejoin='round'
            className='me-2'
        >
            <polyline points='9 11 12 14 22 4'></polyline>
            <path d='M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11'></path>
        </svg>
    ),

    info: (
        <svg
            viewBox='0 0 24 24'
            width='24'
            height='24'
            stroke='currentColor'
            strokeWidth='2'
            fill='none'
            strokeLinecap='round'
            strokeLinejoin='round'
            className='me-2'
        >
            <circle cx='12' cy='12' r='10'></circle>
            <line x1='12' y1='16' x2='12' y2='12'></line>
            <line x1='12' y1='8' x2='12.01' y2='8'></line>
        </svg>
    ),

    warning: (
        <svg
            viewBox='0 0 24 24'
            width='24'
            height='24'
            stroke='currentColor'
            strokeWidth='2'
            fill='none'
            strokeLinecap='round'
            strokeLinejoin='round'
            className='me-2'
        >
            <path d='M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z'></path>
            <line x1='12' y1='9' x2='12' y2='13'></line>
            <line x1='12' y1='17' x2='12.01' y2='17'></line>
        </svg>
    ),

    error: (
        <svg
            viewBox='0 0 24 24'
            width='24'
            height='24'
            stroke='currentColor'
            strokeWidth='2'
            fill='none'
            strokeLinecap='round'
            strokeLinejoin='round'
            className='me-2'
        >
            <polygon points='7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2'></polygon>
            <line x1='15' y1='9' x2='9' y2='15'></line>
            <line x1='9' y1='9' x2='15' y2='15'></line>
        </svg>
    ),
}

const DbtDashboard = ({ }) => {
    const [dbtJobs, setDbtJobs] = useState([]);
    const [failedDbtJobs, setFailedDbtJobs] = useState([]);
    const [successfulDbtJobs, setSuccessfulDbtJobs] = useState([]);
    const [showSuccessfulDbtJobsAlert, setShowSuccessfulDbtJobsAlert] = useState(false);
    const [showFailedDbtJobsAlert, setShowFailedDbtJobsAlert] = useState(false);
    const [showEdmAlert, setShowEdmAlert] = useState(false);
    const [dbtSummaries, setDbtSummaries] = useState([]);
    const [showFlowReDoErrorAlert, setShowFlowReDoErrorAlert] = useState(false);
    const [showFlowReDoWarningAlert, setShowFlowReDoWarningAlert] = useState(false);

    const ColumnFilter = ({ column }) => {
        const { filterValue, setFilter } = column
        return (
            <div>
                <input className="form-control input-search"
                    value={filterValue || ''} onChange={e => setFilter(e.target.value)} />
            </div>
        )
    }

    const GlobalFilter = ({ filter, setFilter }) => {
        return (
            <div>
                Global Search : {' '}
                <input className="ml-2 input-search form-control"
                    value={filter || ''} onChange={e => setFilter(e.target.value)} style={{ width: "100%" }}
                />
            </div>
        )
    }

    const columns = useMemo(() => [
        {
            Header: 'Status',
            Filter: ColumnFilter,
            accessor: 'run_failure_count',
            Cell: ({ cell: { value } }) => {
                const statusClass = value === 0 ? 'text-success' : 'text-danger';
                const displayValue = value === 0 ? 'Success' : String(value).charAt(0).toUpperCase() + String(value).slice(1);
                return <span className={statusClass}>{displayValue}</span>;
            }
        },
        {
            Header: 'Run Again',
            Cell: ({ row }) => {
                const { run_failure_count } = row.original;
                return run_failure_count > 0 ? (
                    <Button className="me-2" variant="outline-secondary" disabled style={{ color: '#24365c' }}>
                        Can't rerun
                    </Button>
                ) : (
                    <Button className="me-2" variant="outline-secondary">
                        Re-run
                    </Button>
                );
            }
        },
        {
            Header: 'Job ID',
            Filter: ColumnFilter,
            accessor: 'id'
        },
        {
            Header: 'Job Name',
            accessor: 'name',
            Filter: ColumnFilter,
        },
        {
            Header: 'Job State',
            Filter: ColumnFilter,
            accessor: 'state',
        },
        {
            Header: 'Job Type',
            Filter: ColumnFilter,
            accessor: 'job_type'
        },
        {
            Header: 'Description',
            Filter: ColumnFilter,
            accessor: 'description',
            Cell: ({ cell: { value } }) => {
                return <span>{value || 'No description added'}</span>;
            }
        },
        {
            Header: 'Updated At',
            Filter: ColumnFilter,
            accessor: 'updated_at',
            Cell: ({ cell: { value } }) => {
                return <span>{value || 'No description added'}</span>;
            }
        },
        {
            Header: 'Schedule',
            Filter: ColumnFilter,
            accessor: 'cron_humanized'

        },



    ], []);

    // Assuming your API returns { data: [...] }
    const data = useMemo(() => {
        const jobsArray = dbtJobs?.data || [];

        return jobsArray;
    }, [dbtJobs]);

    // Create table instance
    const tableInstance = useTable({ columns, data }, useFilters, useGlobalFilter, useSortBy, usePagination)

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        page,
        canNextPage,
        canPreviousPage,
        nextPage,
        previousPage,
        gotoPage,
        pageCount,
        pageOptions,
        state,
        setGlobalFilter,
        preGlobalFilteredRows,
    } = tableInstance;

    const { globalFilter, pageIndex } = state;

    // const { authState } = useOktaAuth();

    // const username = useMemo(() => authState?.idToken?.claims?.name ?? "Unknown", [authState])
    // const userEmail = useMemo(() => authState?.idToken?.claims?.email ?? "Unknown", [authState])
    // console.log("rtbf ")
    // console.log(userEmail)

    const { accounts } = useMsal();

    const username = useMemo(() => accounts[0].name ?? "Unknown", [accounts])
    const userEmail = useMemo(() => accounts[0].username ?? "Unknown", [accounts])

    useEffect(() => {
        async function fetchData() {
            try {
                const dbtJobs = await getDbtJobs();

                const failedDbtJobs = await getFailedDbtJobs();

                const successfulDbtJobs = await getSuccessfulDbtJobs();


                setDbtJobs(dbtJobs);
                setFailedDbtJobs(failedDbtJobs);
                setSuccessfulDbtJobs(successfulDbtJobs);


                if (dbtJobs.length === 0) {
                    setDbtSummaries("No dbt jobs found");

                } else {
                    // Generate the summary
                    const dbtSummary = {};

                    const envNames = new Set();


                    const totalJobCount = dbtJobs.data.length;
                    const totalSuccessfulCount = successfulDbtJobs.length;
                    const totalFailedCount = failedDbtJobs.length;

                    // Create summary object
                    const summaries = {
                        totalJobCount,
                        totalSuccessfulCount,
                        totalFailedCount
                    };



                    setDbtSummaries(summaries);
                }


            } catch (error) {
                console.error("Error fetching approvals:", error);
            }
        }
        fetchData();
    }, []);




    const handleEDMTeamConnect = () => {
        setShowEdmAlert(true);
    };



    const svg1 = (
        <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" className="svg-main-icon">
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <rect x="0" y="0" width="24" height="24"></rect>
                <path d="M17,8 C16.4477153,8 16,7.55228475 16,7 C16,6.44771525 16.4477153,6 17,6 L18,6 C20.209139,6 22,7.790861 22,10 L22,18 C22,20.209139 20.209139,22 18,22 L6,22 C3.790861,22 2,20.209139 2,18 L2,9.99305689 C2,7.7839179 3.790861,5.99305689 6,5.99305689 L7.00000482,5.99305689 C7.55228957,5.99305689 8.00000482,6.44077214 8.00000482,6.99305689 C8.00000482,7.54534164 7.55228957,7.99305689 7.00000482,7.99305689 L6,7.99305689 C4.8954305,7.99305689 4,8.88848739 4,9.99305689 L4,18 C4,19.1045695 4.8954305,20 6,20 L18,20 C19.1045695,20 20,19.1045695 20,18 L20,10 C20,8.8954305 19.1045695,8 18,8 L17,8 Z" fill="#000000" fillRule="nonzero" opacity="0.3"></path>
                <rect fill="#000000" opacity="0.3" transform="translate(12.000000, 8.000000) scale(1, -1) rotate(-180.000000) translate(-12.000000, -8.000000) " x="11" y="2" width="2" height="12" rx="1"></rect>
                <path d="M12,2.58578644 L14.2928932,0.292893219 C14.6834175,-0.0976310729 15.3165825,-0.0976310729 15.7071068,0.292893219 C16.0976311,0.683417511 16.0976311,1.31658249 15.7071068,1.70710678 L12.7071068,4.70710678 C12.3165825,5.09763107 11.6834175,5.09763107 11.2928932,4.70710678 L8.29289322,1.70710678 C7.90236893,1.31658249 7.90236893,0.683417511 8.29289322,0.292893219 C8.68341751,-0.0976310729 9.31658249,-0.0976310729 9.70710678,0.292893219 L12,2.58578644 Z" fill="#000000" fillRule="nonzero" transform="translate(12.000000, 2.500000) scale(1, -1) translate(-12.000000, -2.500000) "></path>
            </g>
        </svg>
    );








    return (

        <Fragment>
            <div className='row pt-5 justify-content-center align-items-center text-center'>
                
                {/* <h1 className='title mb-0'>DBT Jobs Trust Portal</h1> */}
            </div>

            <Col className="mt-5" lg={12}>
                <Card>
                    <Card.Header>
                        <Card.Title>DBT Jobs</Card.Title>
                    </Card.Header>
                    <Card.Body>
                        <div style={{ borderBottom: '2px solid #3d4465', paddingBottom: '10px', marginBottom: '10px' }}>
                            <p style={{ color: '#3a7afe', fontWeight: 'bold' }}>
                                Overall Jobs Status: <span>{dbtSummaries.totalJobCount || 0}</span> jobs ran with <span style={{ color: 'green' }}>{dbtSummaries.totalSuccessfulCount || 0}</span> successful and <span style={{ color: 'red' }}>{dbtSummaries.totalFailedCount || 0}</span>
                            </p>
                            <p style={{ color: '#3a7afe', fontWeight: 'bold' }}>
                                Overall Job Status Score: <span style={{
                                    color:
                                        ((dbtSummaries.totalSuccessfulCount / dbtSummaries.totalJobCount) * 100) < 60 ? 'red' :
                                            ((dbtSummaries.totalSuccessfulCount / dbtSummaries.totalJobCount) * 100) < 90 ? 'orange' :
                                                'green'
                                }}>
                                    {((dbtSummaries.totalSuccessfulCount / dbtSummaries.totalJobCount) * 100).toFixed(2) || 0}%
                                </span>
                            </p>
                        </div>


                        <Table {...getTableProps()} responsive>
                            <thead>
                                {headerGroups.map(headerGroup => (
                                    <tr {...headerGroup.getHeaderGroupProps()}>
                                        {headerGroup.headers.map(column => (
                                            <th
                                                {...column.getHeaderProps(column.getSortByToggleProps())}
                                                style={{ cursor: 'pointer', verticalAlign: 'top' }}
                                            >
                                                {column.render('Header')}
                                                <span>
                                                    {column.isSorted
                                                        ? column.isSortedDesc ? ' 🔽' : ' 🔼'
                                                        : ''}
                                                </span>
                                                {column.canFilter ? <div>{column.render('Filter')}</div> : null}
                                            </th>
                                        ))}
                                    </tr>
                                ))}
                            </thead>
                            <tbody {...getTableBodyProps()}>
                                {page.map(row => {
                                    prepareRow(row);
                                    return (
                                        <tr {...row.getRowProps()}>
                                            {row.cells.map(cell => (
                                                <td {...cell.getCellProps()}>
                                                    {cell.render('Cell')}
                                                </td>
                                            ))}
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </Table>

                        {/* Pagination Controls */}
                        <div className="d-flex flex-column align-items-end mt-3">
                            <span>
                                Page{' '}
                                <strong>
                                    {pageIndex + 1} of {pageOptions.length}
                                </strong>{' '}
                            </span>
                            <span className="table-index mt-4">
                                Go to page:{' '}
                                <input
                                    type="number"
                                    className="ml-2"
                                    defaultValue={pageIndex + 1}
                                    onChange={e => {
                                        const pageNumber = e.target.value ? Number(e.target.value) - 1 : 0;
                                        gotoPage(pageNumber);
                                    }}
                                    style={{ width: '60px', marginLeft: '5px' }}
                                />
                            </span>
                        </div>
                        <div className="text-center">
                            <div className="filter-pagination mt-3">
                                <button className="previous-button" onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
                                    {'<<'}
                                </button>
                                <button className="previous-button" onClick={() => previousPage()} disabled={!canPreviousPage}>
                                    Previous
                                </button>
                                <button className="next-button" onClick={() => nextPage()} disabled={!canNextPage}>
                                    Next
                                </button>
                                <button className="next-button" onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
                                    {'>>'}
                                </button>
                            </div>
                        </div>

                    </Card.Body>
                </Card>
            </Col>
            <Row className="justify-content-center">
                <Col xs={12} md={3} style={{ paddingLeft: '0', display: 'flex', justifyContent: 'center' }}>
                    <Button style={{ width: '100%', maxWidth: '200px' }} variant="light" onClick={handleEDMTeamConnect}>
                        Connect with EDM Team
                    </Button>
                </Col>

            </Row>
            {showEdmAlert && (
                <div style={{
                    position: 'fixed',
                    top: '50%',
                    left: '55%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 1050,
                    width: '80%',
                    maxWidth: '600px'
                }}>
                    <Alert variant="secondary" dismissible onClose={() => setShowEdmAlert(false)} className="solid">
                        {/* Add your emojis and messages here as before */}
                        <strong>Done! </strong> EDM team has been notified and will reach out to you via email shortly.
                        <button type="button" className="btn-close" onClick={() => setShowEdmAlert(false)}>
                            <span><i className="mdi mdi-close" /></span>
                        </button>
                    </Alert>
                </div>
            )}
        </Fragment>
    );

};

export default DbtDashboard;
